import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList, ViewChild } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggle, MatButtonToggleChange, MatButtonToggleGroup, MatButtonToggleModule } from '@angular/material/button-toggle';
import { DateRange } from '@angular/material/datepicker';
import { ChartHelper, TimeRangeOption, TimeRangeOptions } from '@ird/shared-utils';
import moment, { Moment } from 'moment';

@Component({
  selector: 'spx-timerange-picker',
  templateUrl: './time-range-picker.component.html',
  styleUrls: ['./time-range-picker.component.scss'],
  imports: [FormsModule, MatButtonToggleModule, MatButtonModule, FlexLayoutModule],
})
export class TimeRangePickerComponent implements AfterContentInit {
  @Input() disabled = false;
  @Input()
  set chosenTimeRange(value: TimeRangeOption) {
    this._chosenTimeRange = value;
    this.chosenTimeRangeId = value?.id;
  }
  get chosenTimeRange(): TimeRangeOption {
    return this._chosenTimeRange;
  }
  @Input() occurrenceTime?: number;

  @Output() chosenTimeRangeChange: EventEmitter<TimeRangeOption> = new EventEmitter<TimeRangeOption>();
  @Output() timeRangeChange: EventEmitter<DateRange<Moment>> = new EventEmitter<DateRange<Moment>>();

  @ViewChild('toggleGroup', { static: true }) toggleGroup: MatButtonToggleGroup;
  @ContentChildren(MatButtonToggle) toggleButtons: QueryList<MatButtonToggle>;

  private _chosenTimeRange: TimeRangeOption;
  chosenTimeRangeId: string;

  ngAfterContentInit() {
    this.toggleButtons.changes.subscribe(() => {
      this.assignButtons(this.toggleButtons);
    });

    this.assignButtons(this.toggleButtons);

    this.calculateTimeRange({ value: this.chosenTimeRangeId } as MatButtonToggleChange);
  }

  /**
   * Set Time Range for 1 day/week/month or 24hours
   */
  public calculateTimeRange(elem: MatButtonToggleChange): void {
    const timeRange = TimeRangeOptions.getById(elem.value);
    if (timeRange) {
      this.chosenTimeRangeChange.emit(timeRange);
      const range = ChartHelper.getChartTimeRange(timeRange, this.occurrenceTime);
      this.timeRangeChange.emit(new DateRange(moment(range.from), moment(range.to)));
    }
  }

  private assignButtons(buttons: QueryList<MatButtonToggle>): void {
    if (buttons) {
      buttons.forEach((button) => {
        button.buttonToggleGroup = this.toggleGroup;
      });
    }
  }
}
